import { useEffect, useRef } from "react";
import "./style.css";
import "../index.css";
import Display from "./Display";
import { FloatButton } from "antd";
import {
  FullscreenOutlined,
  LogoutOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ORG_TYPES, ROUTES } from "../../Common/Constants";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";

const DealerSlideShow = () => {
  const displayRef = useRef(null);
  const navigate = useNavigate();
  const checkAccess = useRequiredAccess([], [ORG_TYPES.DEALER]);

  useEffect(() => {
    checkAccess();
  });

  const openFullscreen = () => {
    const elem = displayRef.current;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };

  return (
    <>
      <FloatButton.Group shape="square" style={{ right: 15 }}>
        <FloatButton
          type="primary"
          onClick={() => navigate(ROUTES.DEALER_EXECUTIVE.link)}
          icon={<HomeOutlined style={{ fontSize: "24px" }} />}
          tooltip="Go to home"
        />
        <FloatButton
          type="primary"
          onClick={openFullscreen}
          icon={<FullscreenOutlined style={{ fontSize: "24px" }} />}
          tooltip="Full Screen"
        />
        <FloatButton
          type="primary"
          onClick={() => navigate(ROUTES.LOGOUT.link)}
          icon={<LogoutOutlined style={{ fontSize: "24px" }} />}
          tooltip="Logout"
        />
      </FloatButton.Group>

      <div ref={displayRef}>
        <Display />
      </div>
    </>
  );
};

export default DealerSlideShow;
